export const CHANNEL_CUSTOM_TYPE = {
    clinical: 'medical_support_channel',
    technicalSupport: 'medicilio_support_channel',
} as const;
